/* eslint-disable react-hooks/exhaustive-deps */
/**
 * ProductQuickAddModalProvider
 */
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import ProductQuickAddModalContext from './product-quick-add-modal-context'

export default function ProductQuickAddModalProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false)
  const [props, setProps] = useState({})

  const open = (obj = {}) => {
    setProps(() => obj)
    setIsOpen(true)
  }
  const close = () => {
    setIsOpen(false)
  }

  useEffect(() => {
    if (!isOpen && !_.isEmpty(props)) {
      setProps({})
    }
  }, [isOpen, props])

  const state = {
    isOpen,
    onRequestClose: close,
    open,
    close,
    ...props,
  }

  return (
    <ProductQuickAddModalContext.Provider value={state}>
      {children}
    </ProductQuickAddModalContext.Provider>
  )
}
